/* eslint-disable react-hooks/exhaustive-deps */
import { PopupCard } from "@/Pages/Influencer/PublicProfile/Component";
import { useAuth } from "@/Providers/Auth";
import { useInfluencer } from "@/Providers/Influencer";
import { Button } from "@/shadcnComponents/ui/button";
import mixpanel from "mixpanel-browser";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { twMerge } from "tailwind-merge";

export const Leaderboard = () => {
  const [leaderboard, setLeaderboard] = useState({
    topInfluencer: [],
    yourPosition: {
      name: "",
      rank: 0,
      slug: "",
    },
  });
  const [openLeaderboardInfo, setOpenLeaderboardInfo] = useState(false);
  const influencerState = useInfluencer();
  const authState = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    influencerState
      ?.getLeaderboard()
      .then((result) => {
        if (result?.success) {
          setLeaderboard(result?.leaderboard);
        }
      })
      .catch(() => {
        console.error("Failed to fetch leaderboard");
      });
  }, []);

  const handleClickLeaderBoardCard = (slug, name, rank) => {
    mixpanel.track("LeaderBoard Card Clicked", { name, slug, rank });
    if (rank === leaderboard?.yourPosition?.rank) {
      authState?.loggedUser?.activePlan
        ? window.open(
            `${window.location.protocol}//${window.location.host}/${slug}`,
            "_blank"
          )
        : navigate("/influencer/payment");
    } else {
      window.open(
        `${window.location.protocol}//${window.location.host}/${slug}`,
        "_blank"
      );
    }
  };

  return (
    <>
      {/* popup */}
      {openLeaderboardInfo && (
        <HowLeaderBoardWorks
          onClick={() => {
            setOpenLeaderboardInfo(false);
          }}
        />
      )}

      {/* Leaderboard */}
      {leaderboard?.topInfluencer && (
        <div
          style={{
            background: "linear-gradient(to right, #FEAC5E, #C779D0, #4BC0C8)",
          }}
          className="min-w-[200px]  h-auto py-[1px] relative flex items-start justify-center rounded-md"
        >
          <div className="bg-[#232323] flex flex-col min-w-[198px] max-w-[198px] p-4  gap-[6px] text-[white]  rounded-md">
            <span className="text-[#FFF] text-center font-[Inter] text-[12px] not-italic font-bold leading-[20px]">
              👑 Creator Leaderboard
            </span>
            <div className="flex justify-between text-[#A3A3A3] text-center font-[Inter] text-[13px] not-italic font-semibold leading-[20px]">
              <span>Name</span>
              <span>Rank</span>
            </div>

            {/* Top Infulencer */}
            {leaderboard?.topInfluencer &&
              leaderboard?.topInfluencer.map((item, index) => {
                return (
                  <div
                    key={index}
                    className={twMerge(
                      `flex px-[8px] py-[6px] cursor-pointer justify-between gap-[30px] rounded-[4px] overflow-ellipsis hover:-translate-y-1 hover:scale-105 duration-300 transition ease-in-out`,
                      `${
                        item?.rank === leaderboard?.yourPosition?.rank
                          ? "bg-[var(--Primary-300,_#FF5C5C)]"
                          : "bg-[linear-gradient(90deg,_rgba(255,_0,_229,_0.50)_0%,_rgba(18,_18,_18,_0.50)_100%)]"
                      }`
                    )}
                    onClick={() =>
                      handleClickLeaderBoardCard(
                        item?.slug,
                        item?.name,
                        item?.rank
                      )
                    }
                  >
                    <span className="text-[#FFF] font-[Inter] text-[12px] not-italic font-normal leading-[20px]">
                      {item?.rank === leaderboard?.yourPosition?.rank
                        ? leaderboard?.yourPosition?.name
                        : item?.name}
                    </span>
                    <span className="text-[#FFF] text-center font-[Inter] text-[14px] not-italic font-bold leading-[20px]">
                      {item?.rank && [1, 2, 3].includes(item?.rank)
                        ? `#${item?.rank}`
                        : item?.rank}
                    </span>
                  </div>
                );
              })}

            {/* Current user Rank */}
            {leaderboard?.yourPosition &&
              !leaderboard?.topInfluencer.some(
                (item) => item?.rank === leaderboard?.yourPosition?.rank
              ) && (
                <div className="cursor-pointer">
                  <div
                    className="flex px-[8px] py-[6px] justify-between gap-[30px] rounded-[4px] bg-[var(--Primary-300,_#FF5C5C)] hover:-translate-y-1 hover:scale-105 duration-300 transition ease-in-out"
                    onClick={() =>
                      handleClickLeaderBoardCard(
                        leaderboard?.yourPosition?.slug,
                        leaderboard?.yourPosition?.name,
                        leaderboard?.yourPosition?.rank
                      )
                    }
                  >
                    <span className="text-[#FFF] font-[Inter] text-[12px] not-italic font-normal leading-[20px]">
                      {leaderboard?.yourPosition?.name}
                    </span>
                    <span className="text-[#FFF] text-center font-[Inter] text-[14px] not-italic font-bold leading-[20px]">
                      {leaderboard?.yourPosition?.rank}
                    </span>
                  </div>
                </div>
              )}

            <div
              className="text-[#EEE] text-center [text-shadow:0px_4px_4px_rgba(0,_0,_0,_0.25)] font-[Inter] text-[10px] not-italic font-extralight leading-[normal] [text-decoration-line:underline] cursor-pointer"
              onClick={() => {
                mixpanel.track(
                  "LeaderBoard Info - How does leaderboard work? - Clicked"
                );
                setOpenLeaderboardInfo(true);
              }}
            >
              How does leaderboard work?
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export const HowLeaderBoardWorks = ({ onClick }) => {
  return (
    <PopupCard>
      <div className="flex flex-col text-center gap-4 text-[#FFF] font-Inter not-italic w-full">
        <div className="text-[32px] font-semibold leading-[normal]">👑</div>
        <div className="flex flex-col gap-2">
          <div className="text-[16px] font-semibold leading-[18px]">
            How does Leaderboard work?
          </div>
          <div className="text-[#9093AA] text-[12px] font-normal leading-[18px]">
            <p className="w-[full] flex gap-1 flex-col">
              <p>
                The leaderboard ranks creators based on profile strength,
                LinkedIn activity, and how updated their anchors profiles are.
              </p>
              <p>
                <b>
                  Top 5 creators stay featured on our website for a week—until
                  someone replaces you.
                </b>
              </p>
              <b className="text-center">All the best!</b>
            </p>
          </div>
        </div>
        <div>
          <Button
            variant="destructive"
            onClick={() => {
              mixpanel.track("LeaderBoard Info Popup - Got it - Clicked");
              onClick();
            }}
          >
            <span className="text-[14px] font-semibold leading-[24px]">
              Got it
            </span>
          </Button>
        </div>
      </div>
    </PopupCard>
  );
};

export const HowChipsWorks = ({ onClick }) => {
  return (
    <PopupCard>
      <div className="flex flex-col text-center gap-4 text-[#FFF] font-Inter not-italic w-full">
        <div className="text-[32px] font-semibold leading-[normal]">🪙</div>
        <div className="flex flex-col gap-2">
          <div className="text-[16px] font-semibold leading-[18px]">
            How chips can be increased?
          </div>
          <div className="text-[#9093AA] text-[12px] font-normal leading-[18px]">
            <ul className="w-[full] flex gap-1 flex-col list-disc ml-4 text-start ">
              <li>Complete your profile – Accurate details = more chips.</li>
              <li>
                Invite friends – Earn 20 chips for every friend who joins.
              </li>
              <li>
                Stay active – Update your profile and grab bonus collabs! 😉
              </li>
            </ul>
          </div>
        </div>
        <div>
          <Button
            variant="destructive"
            onClick={() => {
              mixpanel.track("LeaderBoard Info Popup - Got it - Clicked");
              onClick();
            }}
          >
            <span className="text-[14px] font-semibold leading-[24px]">
              Got it
            </span>
          </Button>
        </div>
      </div>
    </PopupCard>
  );
};
